import React from 'react'
import { ThemeProvider } from 'styled-components'

import { useTranslation } from '../../contexts/I18nContext'

import Styled from './RecipeDifficultyIndicator.styled'

const getDifficultyConfig = (difficulty) => {
  switch (difficulty) {
    case 0:
    case 1:
    default:
      return {
        i18nKey: 'RECIPE.DIFFICULTY_LEVELS.VERY_EASY',
        level: 1,
      }
    case 2:
      return {
        i18nKey: 'RECIPE.DIFFICULTY_LEVELS.EASY',
        level: 2,
      }
    case 3:
      return {
        i18nKey: 'RECIPE.DIFFICULTY_LEVELS.MEDIUM',
        level: 3,
      }
  }
}

const RecipeDifficultyIndicator = ({
  className,
  difficulty,
  variant,
  direction,
}) => {
  const { t } = useTranslation()
  const config = getDifficultyConfig(difficulty)

  return (
    <ThemeProvider theme={{ variant, direction }}>
      <Styled
        className={className}
        title={`${t('RECIPE.DIFFICULTY')} "${t(config.i18nKey)}"`}
      >
        <Styled.container>
          <Styled.label>{t(config.i18nKey)}</Styled.label>
          <Styled.signal>
            <Styled.signalBar $isActive={config.level >= 1} />
            <Styled.signalBar $isActive={config.level >= 2} />
            <Styled.signalBar $isActive={config.level >= 3} />
          </Styled.signal>
        </Styled.container>
      </Styled>
    </ThemeProvider>
  )
}

RecipeDifficultyIndicator.defaultProps = {
  variant: 'white',
  direction: 'horizontal',
}

export default RecipeDifficultyIndicator
